"use client";
import React, { useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";

const RefundReturnPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>

      <main className="flex pb-4 w-full bg-[#fff8ef] max-md:p-5 max-sm:p-4">
        <section className="flex-1">
          {/* <h2 className="text-xl font-semibold text-gray-800 text-center mb-6">
            Refund & Return Policy
          </h2> */}

          <div className="bg-white rounded-2xl shadow-lg p-8 max-w-5xl mt-10 mx-auto text-gray-700 space-y-5">
             <div className="flex items-center justify-center gap-3 mb-8">
                <div
  className="text-4xl sm:text-4xl md:text-4xl lg:text-4xl 
  font-bold leading-tight text-black 
  tracking-[1px] md:tracking-[2px] 
  text-center px-3"
>
  Refund & <span className="block sm:inline">Return Policy</span>
</div>
              </div>
            <p>
              Since <strong>Manaprint</strong> products are customized, we follow
              a strict quality-based refund policy.
            </p>

            <p>
              <strong>No returns or refunds</strong> are accepted for customized
              products unless the item is damaged, defective, or incorrect.
            </p>

            <p>
              <strong>Eligible cases:</strong> wrong product delivered, printing
              defects, or damage during shipping.
            </p>

            <p>
              <strong>Reporting issues:</strong> customers must report issues
              within <strong>48 hours</strong> of delivery along with photos.
            </p>

            <p>
              <strong>Resolution:</strong> approved cases may receive a
              replacement or refund based on evaluation.
            </p>

            <p>
              <strong>Refund timeline:</strong> refunds are processed within
              5–7 business days after approval.
            </p>

            <p>
              To raise a request, email us at{' '}
              <strong>manaprint6@gmail.com</strong>.
            </p>
          </div>
        </section>
      </main>

      {/* <Footer /> */}
    </div>
  );
};

export default RefundReturnPolicy;
